/*
 * Load style CSS for correct device on resize
 * */
import emit from './Emit';

export default class LoadStylesService {
  /*
   * Load style in the page
   *
   * @param {string} href - url file
   * @param {string} media - no required media for file
   * @param {boolean} enableLoaded - enable event load
   *
   * @return boolean
   * */
  public static loaderStyle(
    href: string,
    media = '',
    enableLoaded = false
  ): boolean {
    if (!href) {
      return false;
    }

    const loader =
      requestAnimationFrame ||
      // @ts-ignore
      // eslint-disable-next-line no-undef
      webkitRequestAnimationFrame ||
      // @ts-ignore
      // eslint-disable-next-line no-undef
      msRequestAnimationFrame ||
      // @ts-ignore
      // eslint-disable-next-line no-undef
      mozRequestAnimationFrame;

    if (loader) {
      loader(() => LoadStylesService.createStyle(href, media, enableLoaded));
    } else {
      window.addEventListener(
        'load',
        LoadStylesService.createStyle(href, media, enableLoaded),
        { passive: true }
      );
    }
    return true;
  }

  /*
   * Create element <link>
   *
   * @param {string} href - url file
   * @param {string} media - no required media for file
   * @param {boolean} enableLoaded - enable event load
   * */
  private static createStyle(
    href: string,
    media = '',
    enableLoaded = false
  ): any {
    const newStyleElt: HTMLElement = document.createElement('link');
    const titleTag: HTMLElement = document.getElementsByTagName('title')[0];

    if (media) {
      newStyleElt.setAttribute('media', media);
    }
    newStyleElt.setAttribute('href', href);
    newStyleElt.setAttribute('rel', 'stylesheet');
    titleTag.parentNode.insertBefore(newStyleElt, titleTag);
    document.body.appendChild(newStyleElt);

    if (enableLoaded) {
      const elementLoaded = document.createElement('img');
      elementLoaded.onerror = () => {
        // Code to execute when the stylesheet is loaded
        document.body.removeChild(elementLoaded);

        // Create the event
        emit('load-search-css', {
          detail: 'Emit an event',
        });
      };
      document.body.appendChild(elementLoaded);
      elementLoaded.src = href;
    }
  }
}
